import { Checkbox as MUICheckbox, FormControlLabel, FormControlLabelProps, FormHelperText } from '@mui/material'
import { FieldValues, useController, UseControllerProps } from 'react-hook-form'

type UpdatedFormControlLabelProps = Omit<FormControlLabelProps, 'control'>

export const Checkbox = <T extends FieldValues>({
  control,
  name,
  defaultValue,
  rules,
  ...rest
}: UpdatedFormControlLabelProps & UseControllerProps<T>) => {
  const {
    field: { value, ref, ...field },
    fieldState: { error },
  } = useController({
    name,
    control,
    rules,
    defaultValue,
  })

  return (
    <>
      <FormControlLabel inputRef={ref} control={<MUICheckbox {...field} checked={value || false} />} {...rest} />
      {error && error.message ? <FormHelperText error>{error.message}</FormHelperText> : null}
    </>
  )
}
